"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParameters = void 0;
const getQueryParameters = (queryString) => {
    const queryArray = queryString.replace('?', '').split('&');
    const queryObject = queryArray.reduce((object, item) => {
        if (item) {
            const value = item.split('=');
            object[value[0]] = value[1];
            return object;
        }
    }, {}) || {};
    return queryObject;
};
exports.getQueryParameters = getQueryParameters;
//# sourceMappingURL=query-params.js.map